export default "__VITE_ASSET__daeca39d__"